import React from "react";
import useWindowSize from "../../hooks/useWindowSize";
import { useNavigate } from "@reach/router";

const LandingImageBanner = ({
  src,
  mobileSrc,
  title,
  description,
  buttonText,
  url,
  onButtonClick,
}) => {
  const navigate = useNavigate();

  const smallDevice = useWindowSize(767);
  const bannerSrc = smallDevice && mobileSrc ? mobileSrc : src;

  const handleClick = () => {
    if (typeof onButtonClick === "function") {
      onButtonClick();
      return;
    }
    if (!url) return;

    if (url.startsWith("http")) {
      window.location.href = url;
    } else {
      navigate(url);
    }
  };

  return (
    <div className="container-fluid monterrey-banner bg-white position-relative">
      <img
        className="monterrey-banner__bg"
        alt={title || "banner"}
        src={bannerSrc}
      />
      <div className="monterrey-banner__overlay">
        {title && (
          <h3 className="monterrey-banner__title mt-5 pt-5">{title}</h3>
        )}
        {description && (
          <p className="monterrey-banner__description">{description}</p>
        )}
        {(buttonText && (url || onButtonClick)) && (
          <button
            type="button"
            className="btn"
            style={{ backgroundColor: "#FFBFA3", color: "var(--dark)", borderRadius: "40px", padding: "10px 20px" }}
            onClick={handleClick}
          >
            {buttonText}
            <i className="fas fa-arrow-right ms-2" />
          </button>
        )}
      </div>
    </div>
  );
};

export default LandingImageBanner;
